import React from "react";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell,
} from "recharts";
import { useSelector } from "react-redux";

export const ImpactScoreChart = ({ data, props }) => {
    const labelFontSize = useSelector((state) => {
        const fontSizes = state.fontManager.fontSizes;
        const normalizedKey = Object.keys(fontSizes).find(
            (key) => key.trim() === "labelFontSize",
        );
        return fontSizes[normalizedKey] || 16;
    });

    const minImpact = Math.min(...data.map(d => d.impactScore));
    const maxImpact = Math.max(...data.map(d => d.impactScore));
    const xDomain = [
        Math.floor(minImpact * 1.2),
        Math.ceil(maxImpact * 1.2),
    ];
    const defaultHeight = props.widget.layout.h * 40 - 135;

    return (
        <>
            <div className="sentiment-container" style={{ marginRight: "10px" }}>
                <div className="sentiment ">
                    <div className="color-box" style={{ marginRight: "20px", background: "rgb(120, 208, 239)" }}></div>
                    Positive Impact Score
                </div>
                <div className="sentiment ">
                    <div className="color-box" style={{ background: "rgb(245, 150, 148)" }}></div>
                    Negative Impact Score
                </div>
            </div>
            <ResponsiveContainer width={"100%"} height={defaultHeight}>
                <BarChart
                    data={data}
                    layout="vertical"
                    margin={{ top: 20, right: 50, left: 0, bottom: 60 }}
                >
                    <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} />

                    <XAxis
                        type="number"
                        domain={xDomain}
                        tick={{ fontSize: 16 }}
                        allowDecimals={false}
                        tickFormatter={(value) => Math.round(value)}
                        padding={{ left: 20, right: 20 }}
                        label={{ value: "Impact Score", position: "bottom", fontSize: 16 }}
                    />

                    <YAxis
                        type="category"
                        dataKey="name"
                        tick={{ fontSize: 16 }}
                        interval={0}
                        width={120}
                    />

                    <Tooltip formatter={(value) => `${Number(value).toFixed(3)}`} contentStyle={{ fontSize: "14px" }} />
                    {/*<Legend content={<CustomLegend />} wrapperStyle={{ fontSize: '14px' }} />*/}

                    <Bar dataKey="impactScore" barSize={20}>
                        {data.map((entry, index) => (
                            <Cell
                                key={`cell-${index}`}
                                fill={entry.impactScore >= 0 ? "rgb(120, 208, 239)" : "rgb(245, 150, 148)"}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </>

    );
};
